import { mapApiCustomerToDetailView } from "../../../../../utils/customerMappers";

export function buildCustomerEditForm(customer) {
  const view = mapApiCustomerToDetailView(customer);
  if (!view) return null;

  const primaryPhone =
    view.phones?.find((p) => p.is_primary)?.number ||
    view.phones?.[0]?.number ||
    (view.phone && view.phone !== "—" ? view.phone : "");

  const groupNames = {};
  (customer.groups || []).forEach((g) => {
    const id = g.id || g._id;
    if (id) groupNames[id] = g.name || g.title || "";
  });

  return {
    name: view.name,
    email: view.email,
    phone: primaryPhone,
    company: view.company === "—" ? "" : view.company,
    groupIds: [...(view.groupIds || [])],
    groupNames,
    groupSelect: "",
    tags: [...(view.tags || [])],
    website: view.websites?.[0] || "",
    city: view.address?.city || "",
    country: view.address?.country || "",
    status: view.status,
    avatar: view.avatar,
    avatarFile: null,
    avatarPreview: null,
  };
}
